import axios from 'axios';

// Đăng nhập người dùng
export const loginUser = (userData) => async (dispatch) => {
  try {
    dispatch({ type: 'USER_LOGIN_REQUEST' });

    // Giả sử có API đăng nhập
    const { data } = await axios.post('/api/users/login', userData);

    dispatch({
      type: 'USER_LOGIN_SUCCESS',
      payload: data,
    });

    localStorage.setItem('userInfo', JSON.stringify(data));
  } catch (error) {
    dispatch({
      type: 'USER_LOGIN_FAIL',
      payload: error.response?.data.message || error.message,
    });
  }
};

// Đăng xuất người dùng
export const logoutUser = () => (dispatch) => {
  dispatch({
    type: 'USER_LOGOUT',
  });

  localStorage.removeItem('userInfo');
  localStorage.removeItem('cartItems'); // Optional: clear cart items on logout
};

// Lấy thông tin người dùng từ localStorage khi tải lại trang
export const getUserInfoFromLocalStorage = () => (dispatch) => {
  const userInfo = localStorage.getItem('userInfo');
  if (userInfo) {
    dispatch({
      type: 'USER_LOGIN_SUCCESS',
      payload: JSON.parse(userInfo),
    });
  }
};
